import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import { useGetAllCategoryListQuery } from "../../../utils/api/category/category.api";
import { FiPhoneCall } from "react-icons/fi";
import VersionChecker from "../../../versionChecker/VersionChecker";

const FrontFooter = () => {
  const { data } = useGetAllCategoryListQuery();
  const date = new Date();

  return (
    <footer className="footer-component">
      <div className="container pt-4 pb-3">
        <div className="row">
          {/* Colonne gauche : All in tech + Contact */}
          <div className="col-lg-4 col-md-6 mb-4 footer-grid">
            <h3 className="footer-brand-title">All in tech</h3>
            <p className="link-footer-title">Contactez-nous</p>
            <div className="footer-contact-us-container">
              <div className="footer-contact-us-item mb-3">
                <span className="footer-contact-icon">
                  <AiOutlineWhatsApp style={{ fontSize: 18 }} />
                </span>
                <p className="link-footer mb-0 pb-0">
                  WhatsApp <br />
                  <Link
                    to="https://wa.me/221772404722"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link-underline"
                  >
                    +221 77 240 47 22
                  </Link>
                </p>
              </div>
              <div className="footer-contact-us-item">
                <span className="footer-contact-icon">
                  <FiPhoneCall style={{ fontSize: 18 }} />
                </span>
                <p className="link-footer pb-0 mb-0">
                  Téléphone <br />
                  <Link to="tel:+221788620404" className="footer-link-underline">
                    +221 78 862 04 04
                  </Link>
                </p>
              </div>
            </div>
          </div>

          {/* Colonne centre : Nos catégories */}
          <div className="mb-4 col-lg-4 col-md-6 footer-grid">
            <p className="link-footer-title title-footer-deco pb-4">
              Nos catégories
            </p>
            <ul className="footer-list">
              {data?.results?.map((item) => (
                <li key={item?.id}>
                  <a
                    href={`/#equipements`}
                    className="link-footer link-footer-deco trans-0-2"
                  >
                    {item?.nom}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne droite : Liens utiles + réseaux */}
          <div className="mb-4 col-lg-4 col-md-6 footer-grid">
            <p className="link-footer-title title-footer-deco pb-4">
              Liens utiles
            </p>
            <ul className="footer-list">
              <li>
                <a className="link-footer link-footer-deco trans-0-2" href="/#fonctionnalités">
                  Fonctionnalités
                </a>
              </li>
              <li>
                <a className="link-footer link-footer-deco trans-0-2" href="/#faq">
                  FAQ
                </a>
              </li>
              <li>
                <a className="link-footer link-footer-deco trans-0-2" href="/#contact">
                  Contact
                </a>
              </li>
            </ul>
            <div className="footer-social-icons">
              <a
                href="https://www.facebook.com/share/1828fuC3vB/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Facebook All in Tech"
              >
                <FaFacebookF size={18} />
              </a>
              <a
                href="https://www.instagram.com/all.in.tech_sn?igsh=Z2RjNDRnOW5taDc0&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Instagram All in Tech"
              >
                <FaInstagram size={18} />
              </a>
              <a
                href="https://www.tiktok.com/@allintech_sn"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="TikTok All in Tech"
              >
                <FaTiktok size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-4 pb-1 copyright-container">
          <div className="footer-separator" />
          <div className="pt-3 text-center copyright-text">
            © {date.getFullYear()}, All in Tech,{" "}
            <span className="copyright-sub">
              Commerce électronique propulsé par{" "}
              <Link
                to="https://easymarket.sn"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link-underline copyright-link"
              >
                Easymarket.sn
              </Link>
            </span>
          </div>
        </div>
        <div className="version-view-container text-end text-white fw-bold">
          {"v" + VersionChecker()}
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;
